import useUser from '../../../../utils/hooks/useUser';
import { isNil } from 'lodash';
import { InstallSlackButton } from '../../../../components/Slack/InstallSlackButton';
import { UninstallSlackButton } from '../../../../components/Slack/UninstallSlackButton';

const ToggleSlackInstallButton = () => {
  const user = useUser();
  if (isNil(user.slackInstallation)) {
    return <InstallSlackButton />;
  } else {
    return <UninstallSlackButton />;
  }
};

export default ToggleSlackInstallButton;
